"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("./Support/BaseUri");
var _q = require("./Support/Query");
var Request = require("./Support/Request");
function getProjects() {
    var url = BaseUri.compose()
        .segment('projects')
        .toString();
    return Request.getJson(url);
}
exports.getProjects = getProjects;
function getSearchPage(_a) {
    var page = _a.page, pageSize = _a.pageSize, folderId = _a.folderId, projectId = _a.projectId;
    var url = BaseUri.compose('projects', 'items', 'search')
        .query(__assign({ '$top': pageSize, '$skip': pageSize * page }, _q.parseArg('f', folderId), _q.parseArg('p', projectId)))
        .readable();
    return Request.getJson(url);
}
exports.getSearchPage = getSearchPage;
function getItemThumbnailUrl(folderItemId) {
    return BaseUri.compose()
        .segment('projects')
        .segment('items')
        .segment("" + folderItemId)
        .segment('thumbnail')
        .toString();
}
exports.getItemThumbnailUrl = getItemThumbnailUrl;
function createProject(project) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('create')
        .toString();
    return Request.postJson(url, project);
}
exports.createProject = createProject;
function addProjectUser(projectId, email, url) {
    var req = BaseUri.compose()
        .segment('projects')
        .segment(projectId.toString())
        .segment('users')
        .toString();
    return Request.postJson(req, { email: email, url: url });
}
exports.addProjectUser = addProjectUser;
function deleteProjectUser(projectId, userId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment(projectId.toString())
        .segment('users')
        .segment(userId.toString())
        .toString();
    return Request.deleteJson(url);
}
exports.deleteProjectUser = deleteProjectUser;
function deleteProject(projectId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment(projectId.toString())
        .toString();
    return Request.deleteJson(url);
}
exports.deleteProject = deleteProject;
function createFolder(projectId, folder) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment(projectId.toString())
        .segment('folders')
        .segment('create')
        .toString();
    return Request.postJson(url, folder);
}
exports.createFolder = createFolder;
function deleteFolder(folderId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('folders')
        .segment(folderId.toString())
        .toString();
    return Request.deleteJson(url);
}
exports.deleteFolder = deleteFolder;
function deleteItem(folderItemId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('items')
        .segment(folderItemId.toString())
        .toString();
    return Request.deleteJson(url);
}
exports.deleteItem = deleteItem;
function getItem(folderItemId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('items')
        .segment(folderItemId.toString())
        .toString();
    return Request.getJson(url);
}
exports.getItem = getItem;
function saveColorway(item) {
    var url = BaseUri.compose()
        .segment('save')
        .segment('colorway')
        .toString();
    return Request.postJson(url, item);
}
exports.saveColorway = saveColorway;
function saveRug(item) {
    var url = BaseUri.compose()
        .segment('save')
        .segment('rug')
        .toString();
    return Request.postJson(url, item);
}
exports.saveRug = saveRug;
function addItemComment(folderItemId, comment) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('items')
        .segment(folderItemId.toString())
        .segment('comments')
        .toString();
    return Request.postJson(url, { comment: comment });
}
exports.addItemComment = addItemComment;
function getItemComments(folderItemId) {
    var url = BaseUri.compose()
        .segment('projects')
        .segment('items')
        .segment(folderItemId.toString())
        .segment('comments')
        .toString();
    return Request.getJson(url);
}
exports.getItemComments = getItemComments;
